// @flow
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import path from 'ramda/es/path';
import clone from 'ramda/es/clone';
import prop from 'ramda/es/prop';

import api from 'app/actions/api';
import action from 'app/common/lib/action';


export default function useRequests() {
  const { t } = useTranslation('identifiers-next');
  const dispatch = useDispatch();

  /**
   *  ЗАПРОС ДАННЫХ
   */
  const handleDataRequest = useCallback(async (personId: number) => {
    const requestPath = 'cabinet/identifiers';
    try {
      const res = await api(requestPath, 'get', { params: { student_id: personId } });
      return path(['data', 'identifiers'], res) || {};
    } catch (error) {
      const errorSave = {
        err: t('request_identifiers_failed'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return null;
    }
  }, [dispatch, t]);

  /**
   *  БЛОКИРОВКА ИДЕНТИФИКАТОРА
   */
  const handleBlockIdentifier = useCallback(async (identifierId: number, reason: string) => {
    const requestPath = 'cabinet/identifiers/disable';
    try {
      const res = await api(requestPath, 'post', { data: { id: identifierId, reason } });
      const { result, ...identifiers } = prop('data', res) || {};
      return identifiers || {};
    } catch (error) {
      const errorSave = {
        err: t('request_identifier_block_failed'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return null;
    }
  }, [dispatch, t]);

  /**
   *  РАЗБЛОКИРОВКА ИДЕНТИФИКАТОРА
   */
  const handleUnblockIdentifier = useCallback(async (identifierId: number) => {
    const requestPath = 'cabinet/identifiers/enable';
    try {
      const res = await api(requestPath, 'post', { data: { id: identifierId } });
      const { result, ...identifiers } = prop('data', res) || {};
      return identifiers || {};
    } catch (error) {
      const errorSave = {
        err: t('request_identifier_unblock_failed'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return null;
    }
  }, [dispatch, t]);

  /**
   *  ПЕРЕНАЗНАЧЕНИЕ ИДЕНТИФИКАТОРА
   */
  const handleReassignIdentifier = useCallback(async (identifierId: number, studentId: number) => {
    const requestPath = 'cabinet/identifiers/reassign';
    try {
      const res = await api(requestPath, 'post', { data: { id: identifierId, student_id: studentId } });
      const { result, ...identifiers } = prop('data', res) || {};
      return identifiers || {};
    } catch (error) {
      const errorSave = {
        err: t('request_identifier_reassign_failed'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return null;
    }
  }, [dispatch, t]);

  /**
   *  ОБНОВЛЕНИЕ АТТРИБУТОВ ИДЕНТИФИКАТОРА
   */
  const handleChangeIdentifierAttribute = useCallback(async (
    identifierId: number,
    attributeName: string,
    attributeValue: mixed
  ) => {
    const requestPath = 'cabinet/identifiers/attributes';
    const type = 'post';
    const rest = {
      data: {
        id: identifierId,
        [attributeName]: attributeValue,
      },
    };
    try {
      const res = await api(requestPath, type, rest);
      const { result, ...identifiers } = prop('data', res) || {};
      return identifiers || {};
    } catch (error) {
      const errorSave = {
        err: t('request_identifier_attribute_change_failed'),
        path: requestPath,
        type,
        rest,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
      return null;
    }
  }, [dispatch, t]);

  return {
    handleDataRequest,
    handleBlockIdentifier,
    handleUnblockIdentifier,
    handleReassignIdentifier,
    handleChangeIdentifierAttribute,
  };
}
